<template>
    <div id="imprint-app-total" class="imprint-app-total">
        <template v-if="applicationType !== 'calendar_single'">

            <template v-if="isComda">
                <div class="imprint-app-total__line">
                    <div class="comda_imprint-app-total__line-title">Unit Price</div>
                    <div class="comda_imprint-app-total__line-title">Total Qty</div>
                    <div class="comda_imprint-app-total__line-title">Subtotal</div>
                </div>
                <div class="imprint-app-total__line comda_underline_line" style="padding-bottom: 10px">
                    <div style="padding: 6px; font-size: 16px; background: #eeeeee;" class="imprint-app-total__line-value">
                        ${{ store.prices.priceByQty ? store.prices.priceByQty.toFixed(2) : 0.00 }} / Each
                    </div>
                    <div style="padding: 6px; font-size: 16px;" class="imprint-app-total__line-value">
                        {{ totalSizesQty }}
                    </div>
                    <div style="padding: 6px; font-size: 16px;" class="imprint-app-total__line-value">
                        {{ formatCurrency(this.totalSizesQty * this.store.prices.priceByQty) }}
                    </div>
                </div>
                <div class="imprint-app-total__fee-wrapp">
                    <div v-if="Object.hasOwn(store.upchargesLines,this.store.imprintKey)">

                    <template v-if="Object.hasOwn(store.upchargesLines[this.store.imprintKey],'color') && Object.keys(store.upchargesLines[this.store.imprintKey].color).length && store.prices.priceColorUpcharge != 0">
                        <div class="comda_imprint-app-total__line">
                            <div v-if="store.productType === 'grouped_plain'" class="comda_imprint-app-total__line-value">
                                Colour Charge
                            </div>
                            <div v-else class="comda_imprint-app-total__line-value">
                                Apparel Color
                                {{ this.store.prices.priceColorUpcharge.toFixed(2) < 0 ? "Downcharge" : "Upcharge" }}
                            </div>
                            <div class="comda_imprint-app-total__line-value">{{ formatCurrency(this.store.prices.priceColorUpcharge) }}</div>
                        </div>
                    </template>

                    <template v-for="(sizePrice, sizeProp) in store.upchargesLines[this.store.imprintKey].size" :key="sizeProp">
                        <div v-if="sizePrice != 0" class="comda_imprint-app-total__line">
                            <div class="comda_imprint-app-total__line-value">
                                Apparel Upsize ({{ sizeProp }})
                              <span class="tooltip-icon" v-if="!isComda">?</span>
                              <span class="fee-tooltiptext" v-if="!isComda">
                                <b>Apparel Upsize</b> Pricing based on extra sizes
                              </span>
                            </div>
                            <div class="comda_imprint-app-total__line-value">
                                {{ formatCurrency(sizePrice) }}
                            </div>
                        </div>
                    </template>
                        </div>
                    <template v-for="(feeLine, index) in store.prices" :key="index">
                        <div class="comda_imprint-app-total__line" v-if="index !== 'tier' && pricesNamePresenter(index) !== false && feeLine != 0">
                            <div class="comda_imprint-app-total__line-value" v-html="pricesNamePresenter(index)">
                            </div>
                            <div class="comda_imprint-app-total__line-value">{{ formatCurrency(feeLine) }}</div>
                        </div>
                    </template>
                    <div class="comda_imprint-app-total__line" style="justify-content: normal">
                        <div class="comda_imprint-app-total__line-value"
                             style="width: 71%; padding-right: 45px; text-align: right;"
                        >
                            Total
                        </div>
                        <div class="comda_imprint-app-total__line-value" style="text-align: left; width: 19%;">
                            {{ formatCurrency(subtotalPrice) }}
                        </div>
                    </div>
                </div>
            </template>

            <template v-if="!isComda">
                <div class="imprint-app-total__line">
                    <div class="imprint-app-total__line-title" :class="[customFont, customColor]">Unit Price</div>
                    <div class="imprint-app-total__line-title" :class="[customFont, customColor]">Total Qty</div>
                </div>
                <div class="imprint-app-total__line">
                    <div class="imprint-app-total__line-value">${{ store.prices.priceByQty ? store.prices.priceByQty.toFixed(2) : 0.00 }} / Each</div>
                    <div class="imprint-app-total__line-value">{{ totalSizesQty }}</div>
                </div>
                <div class="imprint-app-total__fee-wrapp">
                    <div v-if="Object.hasOwn(store.upchargesLines,this.store.imprintKey)">
                        <template v-if="Object.hasOwn(store.upchargesLines[this.store.imprintKey],'color')  && Object.keys(store.upchargesLines[this.store.imprintKey].color).length && store.prices.priceColorUpcharge != 0">
                            <div class="imprint-app-total__line">
                                <div v-if="store.productType === 'grouped_plain'" class="imprint-app-total__line-value">
                                    Colour Charge
                                </div>
                                <div v-else class="imprint-app-total__line-value">
                                    Apparel Color
                                    {{ this.store.prices.priceColorUpcharge.toFixed(2) < 0 ? "Downcharge" : "Upcharge" }}
                                </div>
                                <div class="imprint-app-total__line-value">{{ formatCurrency(this.store.prices.priceColorUpcharge) }}</div>
                            </div>
                        </template>

                    <template v-for="(sizePrice, sizeProp) in store.upchargesLines[this.store.imprintKey].size" :key="sizeProp">
                        <div class="imprint-app-total__line">
                            <div class="imprint-app-total__line-value">
                                Apparel Upsize ({{ sizeProp }}) <span class="tooltip-icon">?</span>

                                <span class="fee-tooltiptext">
                                  <b>Apparel Upsize</b> Pricing based on extra sizes
                                </span>
                            </div>
                            <div class="imprint-app-total__line-value">
                                {{ formatCurrency(sizePrice) }}
                            </div>
                        </div>
                    </template>
                    </div>
                    <template v-for="(feeLine, index) in store.prices" :key="index">
                        <div class="imprint-app-total__line" v-if="index !== 'tier' && pricesNamePresenter(index) !== false">
                            <div class="imprint-app-total__line-value">
                                {{ pricesNamePresenter(index) }}
                            </div>
                            <div class="imprint-app-total__line-value">{{ formatCurrency(feeLine) }}</div>
                        </div>
                    </template>
                </div>
                <div class="imprint-app-total__line">
                    <div class="imprint-app-total__line-title" :class="[customFont, customColor]">Sub-Total</div>
                    <div class="imprint-app-total__line-value sub-total-value">{{ subtotalPrice}}</div>
                </div>
            </template>

        </template>

        <template v-if="applicationType === 'calendar_single'">
            <div class="min-order-qty-text">
                Minimum order for calendar bundles is {{ isComda ? 100 :150 }}  unit(s)
            </div>
            <div class="bundle-butons bundle-butons-wrapper calendar">
                <CustomQty
                    :css-classes="'bundle-butons__item bundle-butons__item--qty'"
                    :modelValue="store.calendar.qtyVal ? store.calendar.qtyVal : 25"
                    :sizeTitle="'QTY'"
                    :displayTitle="true"
                    :lineId="0"
                    :prId="'size-input-single-' + store.inputProuctIds.mainProductID"
                    @customQtyChange="updateStoreState"
                >
                </CustomQty>
                  <a
                      class="bundle-butons__item bundle-butons__item--add-to-bundle arrow-right add_to_cart_type_class--bundle"
                      :class="[customBackground]"
                      :data-product_id="store.inputProuctIds.mainProductID"
                      :data-product_title="store.calendar.productPageTitle"
                      :data-product_image="store.calendar.productImage"
                      :data-product_qty="calendarQty"
                      type="submit"
                      onclick=""
                  >
                    Add to Bundle
                  </a>
                <button
                    class="bundle-butons__item bundle-butons__item--back-to-themes arrow-left"
                    :class="[customBackgroundHover]"
                    @click="navigateToCalendars()"
                >
                    Back to themes
                </button>
            </div>

        </template>
    </div>
</template>

<script>
import { store } from './store.js';
import CustomQty from './CustomQty.vue';
//import axios from 'axios'

export default {
    props: {
        newImprint: Object,
        newTierData: Object,
        step: Number,
        applicationType: String,
    },
    components: {
        CustomQty
    },
    data() {
        return {
            totalQty: 0,
            subtotal: 0,
            store: store,
            feeData: {},
            calendarQty: 0,
            isTooltip: true
        }
    },
    computed: {
        totalSizesQty: function () {
            let defaultQty = this.store.productType === 'grouped_plain' ? store.prices.tier[1].QtyMin : 0;

            return this.store.totalSizesQty[this.store.imprintKey] ? this.store.totalSizesQty[this.store.imprintKey] : defaultQty;
        },
        subtotalPrice: function () {

            //if(!this.store.prices.priceByQty) {
            this.calculatePriceByQty();
            //}
            this.calculateSetupFee();
            this.calculateRunningFee();
            this.calculateImageFee();
            this.calculateProofFee();
            this.calculateCustomColorFee();
            this.calculateColorUpcharge();
            this.calculateSizeUpcharge();

            console.error("ImprintAppSummary this.store.selectedImprint.sku");
            console.warn(this.store);
            console.error("this.store.selectedImprint.sku");
            console.error(this.store.selectedImprint.sku);
            console.error(this.store.prices);
            console.error(this.store.imprintMessageColorLines[this.store.imprintKey]);
            console.error(this.newImprint);
            console.error(this.newTierData);

            console.warn(" (1) priceByQty: " + this.totalSizesQty * this.store.prices.priceByQty
                + " (2) priceSizeUpcharge: " + this.store.prices.priceSizeUpcharge
                + " (3) setupFee: " + this.store.setupFee
                + " (4) running_fee: " + this.store.prices.running_fee
                + " (5) proof_fee: " + this.store.prices.proof_fee
                + " (6) customColourFee: " + this.store.customColourFee
                + " (7) Image_Fee: " + this.store.prices.image_fee
            );

            let result =   (this.totalSizesQty * this.store.prices.priceByQty)
              + this.store.prices.priceSizeUpcharge
              + this.store.prices.setup_fee //
              + this.store.prices.running_fee
              + this.store.prices.proof_fee
              + this.store.prices.image_fee
              + this.store.prices.customColourFee
              + this.store.prices.priceColorUpcharge;

            return  this.formatCurrency(result);
        },
        customColor() {
            return this.$getCustomColorClass(store.storeID);
        },
        customFont() {
            return this.$getCustomFontClass(store.storeID);
        },
        customBackground() {
            return this.$getCustomBackgroundColorClass(store.storeID);
        },
        customBackgroundHover() {
            return this.$getCustomBackgroundColorHoverClass(store.storeID);
        },
        isComda() {
            return store.storeID.includes('comda');
        },
    },
    methods: {
       /* downloadImage(url,title) {
            axios({
                method: 'get',
                url,
                responseType: 'arraybuffer',
            })
                .then((response) => {
                this.forceFileDownload(response, title)
            })
                .catch(() => console.log('error occured'))
        },
        forceFileDownload(response, title) {
            console.log(title)
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', title)
            window.jQuery("#download_image").appendChild(link);
            link.click();
        },*/
        init() {
            this.totalQty = this.store.totalSizesQty[this.store.imprintKey] ? this.store.totalSizesQty[this.store.imprintKey] : this.store.inputProductData.minOrderQty;
            this.subtotal = this.totalQty * this.store.inputProductData.fullJson.configurable_array[this.store.selectedImprint.sku].prices_2.price;
        },
        navigateToCalendars() {
            window.location.href = "/collections/calendars";
        },
        getColorUpcharge() {
            let result = 0;

            if(Object.keys(store.upchargesLines[this.store.imprintKey].color)) {
                result = store.upchargesLines[this.store.imprintKey].color[Object.keys(store.upchargesLines[this.store.imprintKey].color)[0]];
                this.store.prices.priceColorUpcharge = result;
            }

            return this.formatCurrency(result);
        },
        pricesNamePresenter(key) {
            let priceNames = {
                setup_fee: 'Setup Fee',
                image_fee: 'Image Fee',
                running_fee: 'Running Fee',
                proof_fee: 'Proof Fee',
                customColourFee: window.Shopify.country === "CA" ? 'Colour Fee' : 'Color Fee',
            };

           /* if(this.isComda){
                priceNames =  this.addTooltips(priceNames);
            }*/

            // eslint-disable-next-line
            return priceNames.hasOwnProperty(key) ? priceNames[key] : false;
        },

        addTooltips(priceNames){
            var colorWord = window.Shopify.country === "CA" ? 'colour' : 'color';
            priceNames.setup_fee += '<span class="tooltip-icon">?</span><span class="fee-tooltiptext"><b>Setup Fee</b>The industry standard cost<br>associated with setting up<br>the screen, die, laser or<br>other necessary items to<br>imprint your specific logo.</span>';
            priceNames.image_fee += '<span class="tooltip-icon">?</span><span class="fee-tooltiptext"><b>Image Fee</b>The fees associated with<br>formatting, retouching,<br>and/or redrawing custom<br>logos.</span>';
            priceNames.running_fee += '<span class="tooltip-icon">?</span><span class="fee-tooltiptext"><b>Running Fee</b>Pricing varies by product<br> ' + colorWord + ', size and material.<br>Standard pricing includes<br> 1 ' + colorWord + ' imprint on<br>standard products, 2XL<br> sizes, different fabrics, etc.<br> may be customized for<br> additional fees.</span>';
            priceNames.proof_fee += '<span class="tooltip-icon">?</span><span class="fee-tooltiptext"><b>Proof Fee</b>The cost to digitize your<br>artwork (company<br>name/logo/message)<br>and digitally render it on a<br>product for review prior to<br>production.</span>'
            priceNames.customColourFee += '<span class="tooltip-icon">?</span><span class="fee-tooltiptext"><b>' + colorWord[0].toUpperCase() + colorWord.slice(1) + ' Fee</b>PMS (Pantone) ' + colorWord + ' <br>match fee, applied when<br> creating non-standard<br>imprint ' + colorWord + ' (matching<br>to existing logo, etc.).</span>';

            return priceNames;
       },
        calculatePriceByQty() {
            let priceByQty = 0;
            let total = this.totalSizesQty;
            let minQtyPrice = 0;
            let hasSpecialPrice = Object.keys(this.store.specialPrice.byImprintMethods).includes(this.store.selectedImprint.sku);

            this.store.prices.tier.forEach(
                item => {
                    if(item.QtyMin !== 'MSRP') {
                        if (total >= item.QtyMin) {
                            priceByQty = hasSpecialPrice ? item['sale_price'] : item.price;
                        }
                    }
                    if(item.QtyMin === this.store.inputProductData.minOrderQty) {
                        minQtyPrice = hasSpecialPrice ? item['sale_price'] : item.price;
                    }
                }
            );

            this.store.prices.priceByQty = Number(priceByQty > 0 ? priceByQty : minQtyPrice);
        },
        calculateSetupFee() {
            console.error("33333333333 calculateSetupFee() 3333333333333");
            console.error(this.store.setupFee);
            if(this.isComda){
              let uniqueColorsCount = this.store.selectedLastStep[this.store.imprintKey].uniqueColorsCount;

              this.store.prices.setup_fee = this.store.perItemFee.setupFee;

              if(uniqueColorsCount && this.store.perItemFee.setupFee) {
                this.store.prices.setup_fee = (uniqueColorsCount) * this.store.perItemFee.setupFee;
              }
            } else  if (this.store.prices.priceByQty) {
                this.store.prices.setup_fee = 0;
                let uniqueColorsCount = this.store.selectedLastStep[this.store.imprintKey].uniqueColorsCount;
                if (uniqueColorsCount && this.store.perItemFee.setupFee) {
                    this.store.prices.setup_fee = (uniqueColorsCount - 1) * this.store.perItemFee.setupFee;
                }
            }
        },
        calculateRunningFee() {
            console.error("444444444444 calculateRunningFee() 4444444444");
            console.error(this.store.prices);
            console.warn(this.store.perItemFee);
            console.warn("Per Item");
            console.log(this.store.perItemFee);
            let uniqueColorsCount = this.store.selectedLastStep[this.store.imprintKey].uniqueColorsCount;

            if (this.store.prices.priceByQty && this.store.imprintMessageColorLines[this.store.imprintKey].length > 1 && uniqueColorsCount > 1) {
                this.store.prices.running_fee = (uniqueColorsCount - 1) * this.store.perItemFee.running_fee * this.store.totalSizesQty[this.store.imprintKey];
            } else {
                this.store.prices.running_fee = 0;
            }
        },
        calculateImageFee() {
            console.error("calculateImageFee");
            console.log(this.store.selectedLastStep[this.store.imprintKey].uploaded_image);
            let imageFeePrice = 0;

            if(this.store.selectedLastStep[this.store.imprintKey].uploaded_image && this.store.selectedLastStep[this.store.imprintKey].uploaded_image.href) {
                imageFeePrice = this.store.perItemFee.image_fee ? this.store.perItemFee.image_fee : 0;
                this.store.prices.image_fee = imageFeePrice;
                console.log("uploaded_image worrrk");
            }
            console.error("!!!!!!!!!!!!!! Prise Image");
            console.log(imageFeePrice);
            return imageFeePrice;
        },
        calculateProofFee() {
            console.error("calculateProofFee");
            console.log(this.store.perItemFee.proof_fee);
            console.log(this.store.lastMaxInitedStep);
            console.log(this.store.prices.proof_fee);
            console.warn(this.store.lastMaxInitedStep > 1);
            let proofFeePrice = 0;

            // from  if(this.store.selectedLastStep[this.store.imprintKey].proof_fee) {
            // to    if(this.store.perItemFee.proof_fee) {

            if(this.isComda || (this.store.lastMaxInitedStep > 2 && this.store.perItemFee.proof_fee && this.totalSizesQty > 0 && this.store.selectedLastStep[this.store.imprintKey].uniqueColorsCount >= 2)) {
                proofFeePrice = this.store.perItemFee.proof_fee ? this.store.perItemFee.proof_fee : 0;
                this.store.prices.proof_fee = proofFeePrice;
            } else {
                this.store.prices.proof_fee = 0;
                proofFeePrice = 0;
            }
            console.error("!!!!!!!!!!!!!! Proof Image");
            console.log(proofFeePrice);
            return proofFeePrice;
        },
        calculateCustomColorFee() {
            this.store.prices.customColourFee = 0;

            if (Object.hasOwn(this.store.customColourFee, this.store.imprintKey)) {
                this.store.prices.customColourFee = this.store.customColourFee[this.store.imprintKey]
            }

        },
        calculateColorUpcharge() {
            this.store.prices.priceColorUpcharge = 0;
            if (Object.hasOwn(this.store.upchargesLines, this.store.imprintKey) && Object.hasOwn(this.store.upchargesLines[this.store.imprintKey], 'color')) {
                for (let color in this.store.upchargesLines[this.store.imprintKey].color) {
                    console.log("inpricein");
                    this.store.prices.priceColorUpcharge += this.store.upchargesLines[this.store.imprintKey].color[color];
                    console.log(this.store.prices.priceColorUpcharge);
                }
            }
        },
        calculateSizeUpcharge() {
            this.store.prices.priceSizeUpcharge = 0;
            if (Object.hasOwn(this.store.upchargesLines, this.store.imprintKey) && Object.hasOwn(this.store.upchargesLines[this.store.imprintKey], 'size')) {
                for (let size in this.store.upchargesLines[this.store.imprintKey].size) {
                    console.log("inpricein");
                    this.store.prices.priceSizeUpcharge += this.store.upchargesLines[this.store.imprintKey].size[size];
                    console.log(this.store.prices.priceColorUpcharge);
                }
            }
        },
        updateStoreState(val) {
            if(val) {
                this.store.totalSizesQty[this.store.imprintKey] = val.value;
                this.store.inputProductData.minOrderQty = val.value;
                this.calendarQty = Number(val.value);
                this.store.calendar.qtyVal = Number(val.value);
                console.error(this.calendarQty);
                console.warn(this.store.calendar.qtyVal);
            }
        },
        formatCurrency(number){
          return  number.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
          });
        }
    },
    created() {
        this.init();
        console.error("$$$$$$$ Calendar bundle");
        console.warn(this.store);
    },
    mounted() {
        if(this.isComda) {
          this.isTooltip = false;
        }
        if (this.store.application_type == 'calendar_single') {
            console.error("++++++++++++ Mounted Application Type ImpSummary +++++++++++++");
            console.log(this.store.application_type);
            this.store.calendar.productPageTitle = window.jQuery("h1.product_name").text();
            this.store.calendar["productImage"] = window.jQuery(window.jQuery(".gallery-cell")[0]).find("a.lightbox").attr("href");
            if(!this.store.calendar["productImage"]){
                this.store.calendar["productImage"] = window.jQuery(window.jQuery(".gallery-cell")[0]).find("img.product-gallery__image").attr("data-src");
            }
            console.log(">>>>");
            console.log(this.store);
        }

        if (this.store.application_type == 'calendar_single' || this.store.application_type == 'calendar') {

            if(window.jQuery("#calendar-qty-changed")) {
                window.jQuery("body").on("click","#calendar-qty-changed",
                    (event)=> {
                        console.log(event);
                        console.warn("ImprintAppSummary qty created hook ");
                        if(window.jQuery("#calendar-imprint-common-qty")) {
                            console.error(window.jQuery("#calendar-imprint-common-qty").val());
                            let qtyValue = window.jQuery("#calendar-imprint-common-qty").val();
                            this.updateStoreState({value: qtyValue});
                        }
                    }
                );
            }
        }
    }
}
</script>

<style>
.tooltip-icon
{
  background-color: #777777;
  color: #fff;
  font-size: 10px;
  border-radius:7px;
  display: inline-block;
  width: 15px;
  height: 15px;
  line-height: 14px;
  position: relative;
  top: -2px;
  left: 3px;
}

.fee-tooltiptext{
  display: none!important;
  position: absolute;
  z-index: 99;
  background-color: #000;
  color: #fff;
  border-radius: 5px;
  padding: 5px 10px;
  font-size: 10px;
  text-align: left;
  margin-left: 10px;
  line-height: 1.4;
  transform: translateY(-50%);
  margin-top: 8px;
}

.tooltip-icon:hover + .fee-tooltiptext{
  display: inline-block!important;
}

.fee-tooltiptext b{
  display:block;
}

.fee-tooltiptext{
  font-size:11px;
  line-height: 15.4px;
}
.fee-tooltiptext::after{
  content: "";
  position: absolute;
  top: 48%;
  left: -3px;
  transform: rotate(45deg);
  margin-left: 0;
  border-width: 5px;
  border-style: solid;
  border-color: black;
}

.product-wrap .image-element__wrap{
  border: 1px solid #707070;
  min-height: 220px;
  display: flex;
  align-items: center;
}

.bundle-butons__item.bundle-butons__item--qty .size-row__input {
    z-index: 1;
}
.min-order-qty-text {
    margin-top: 7px;
    text-align: left;
    font-size: 16px;
    font-family: 'museo-sans', sans-serif;
    font-weight: 300;
    color: #5A5A5A;
}
.imprint-app-total__line {
    display: flex;
    justify-content: space-around;
    padding: 10px 10px 0 10px
}
.imprint-app-total__line-value{
    font-size: 14px;
    width: 40%;
}
.sub-total-value{
    font-weight: 700;
}
.imprint-app-total__line-title {
    font-size: 14px;
    font-weight: 700;
    width: 40%;
}
.comda_imprint-app-total__line-title{
    color: #898989!important;
    font-family: 'Montserrat', 'Helvetica Neue', Verdana, Arial, sans-serif;
    font-weight: 300;
    font-size: 16px;
}
.comda_imprint-app-total__line{
    display: flex;
    justify-content: space-around;
    padding: 10px 10px 0 10px;
    border-bottom: 1px solid #d7d7d7;
}
.comda_imprint-app-total__line-value{
    font-size: 13px;
    width: 40%;
}
.comda_underline_line{
    border-bottom: 1px solid #d7d7d7;
}
.bundle-butons__item.bundle-butons__item--back-to-themes {
    background-color: #969696;
}

.arrow-right{
  margin-right: 10px;
}
.arrow-left{
  position: relative;
}

.arrow-right:after {
  content: "";
  border: solid #fff;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  position: absolute;
  top: 38%;
  right: 8px;

}

.arrow-left:before {
  content: "";
  border: solid #fff;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  position: absolute;
  top: 38%;
  left: 8px;
}

.calendar.bundle-butons{
  justify-content: start;
  flex-wrap: wrap;
}

</style>